import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

const BlockStyleThree = (props = {}) => {
    const {
        kicker = '소프트웨어 개발',
        title = '실무 운영을 고려한 엔터프라이즈 소프트웨어 구축',
        body = '업무 프로세스 분석부터 UI/UX 설계, 개발, 배포, 유지보수까지 기업 환경에 최적화된 소프트웨어를 제공합니다. 확장성과 안정성을 고려한 실무 중심 개발을 원칙으로 합니다.',
        linkTo = '/about',
        linkLabel = '자세히 보기',
    } = props
    return (
        <Fragment>
            <div className="block-style-three mb-45">
                <h6 className="sub-title mb-20">{kicker}</h6>
                <h2 className="sect-title mb-15">{title}</h2>
                <p>{body}</p>
                <Link className="theme_btn mt-55" to={linkTo}>
                    {linkLabel}
                </Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleThree
